// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1lI55","choiceBoxes":"toolbarselects_choiceBoxes__2NCN2","simpleField":"toolbarselects_simpleField__3Qf0D"};